import * as Sentry from '@sentry/react';
import { createRoot } from "react-dom/client";
import App from "./app/App.tsx";
import "./styles/index.css";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN ?? '',
  environment: import.meta.env.MODE,           // 'development' | 'production'
  enabled: import.meta.env.PROD,               // desabilitado em dev local
  tracesSampleRate: 0.1,                       // 10% das transações
  replaysOnErrorSampleRate: 1.0,               // replay completo em erros
  replaysSessionSampleRate: 0.0,               // sem replay em sessões normais
  integrations: [
    Sentry.replayIntegration(),
  ],
});

createRoot(document.getElementById("root")!).render(<App />);
